import { render, staticRenderFns } from "./square_detial.vue?vue&type=template&id=89602492&scoped=true"
import script from "./square_detial.vue?vue&type=script&lang=js"
export * from "./square_detial.vue?vue&type=script&lang=js"
import style0 from "./square_detial.vue?vue&type=style&index=0&id=89602492&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89602492",
  null
  
)

export default component.exports